import i18n from "@/locales";
import { get, post } from "@/modules/request";
import { useGlobalModal } from "@/stores/globalModal";
import { useGlobalUser } from "@/stores/globalUser";
import {
  PageRequest,
  PageResponse,
  Response,
  WriteResponse,
} from "@/types/api-types";
import { showLoadingToast } from "vant";

// 打赏
// 创建支付
export const ApiPostTip = (params: {
  mateId: number;
  crystalQuantity: number;
  tippableId: number;
  tippableType: TippableType;
  text: string;
}): Promise<WriteResponse<Payment>> => post("/Tip", params);

// 获取支付信息
export const ApiPostTipPay = (
  uuid: string,
  params: {
    paymentMethod: PaymentMethod; // 1: balance 2: stripe
    successUrl?: string;
    cancelUrl?: string;
  }
): Promise<Response<{ paymentUrl: string }>> => post(`/TipPay/${uuid}`, params);

// 获取总收益信息
export const ApiGetTransactionOverview = (params: {
  type: TransactionType;
  recentDays: number;
}): Promise<Response<{ mate: Mate; totalAmount: number }[]>> =>
  get(`/TransactionOverview`, params);

export const ApiGetTransactionPage = (
  params: PageRequest<{ type: number; mateId?: number }>
): Promise<PageResponse<TransactionView>> => get(`/TransactionPage`, params);

// 绑定paypal
export const ApiPostUserPaypalBind = (params: {
  paypal: string;
}): Promise<WriteResponse<User>> => post(`/UserPaypalBind`, params);

// 提现
export const ApiPostWithdrawal = (params: {
  mateId: number;
  amount: number;
}): Promise<WriteResponse<Withdrawal>> => post(`/Withdrawal`, params);

export const ApiGetWithdrawalPage = (
  params: PageRequest<{ status?: number }>
): Promise<any> => get(`/WithdrawalPage`, params);

// 高级守护订阅
export const ApiPostAdmireSubscription = async (params: {
  admirerId: number;
  recipientId: number;
  type: number; // 1 Regular 2 Premium
}) => {
  showLoadingToast(i18n.global.t("Message.loading"));
  const { item } = await post("/AdmireSubscription", params);
  const { data } = await post(`/AdmireSubscriptionPay/${item.uuid}`, {
    paymentMethod: 2,
    successUrl: `${window.location.href}#successPayment`,
    cancelUrl: `${window.location.href}#cancelPayment`,
  });
  location.href = data.paymentUrl;
  showLoadingToast(i18n.global.t("Message.paymentRedirecting"));
};

export const ApiPostAdmireSubscriptionCancel = (uuid: string) =>
  post(`/AdmireSubscriptionCancel/${uuid}`);

// 购买资源
export const ApiPostMediaOrder = async (params: {
  purchaserId: number;
  mediaIdzz: number[];
}): Promise<any> => {
  const { item } = await post("/MediaOrder", params);
  return item;
};

// 新版订阅
export const ApiPostSubscription = async (params: {
  subscriptionType: number; // 1 Free 2 starter 3 Premium 4 Deluxe
  billingFrequency: number; // 1 Monthly 2 Yearly
}) => {
  const loading = showLoadingToast(i18n.global.t("Message.loading"));
  const url = window.location.href.split("#")[0];
  const amount = [0, 60, 200, 700][params.subscriptionType - 1];
  const receiveData = {
    list: [{ type: "crystal", amount }],
    type: "Subscription",
    subscriptionType: params.subscriptionType,
  };
  const { data } = await post(`/Subscription`, {
    ...params,
    successUrl: `${url}#successPayment&${encodeURIComponent(
      JSON.stringify(receiveData)
    )}`,
    cancelUrl: `${url}#cancelPayment`,
  });
  location.href = data.paymentUrl;
  loading.message = i18n.global.t("Message.paymentRedirecting");
  setTimeout(() => {
    loading.close();
    useGlobalModal().showSubscribeModal = false;
    useGlobalUser().checkPaymentSuccess(
      receiveData.list,
      receiveData.type,
      receiveData.subscriptionType.toString()
    );
  }, 2000);
};

export const ApiPostSubscriptionTrial = () => post("/SubscriptionTrial");

export const ApiGetStripeBillingPortal = async () =>
  get(
    `/StripeBillingPortal?returnUrl=${encodeURIComponent(window.location.href)}`
  );
